<ngb-alert [type]="'danger'" [hidden]="!show" [dismissible]="false">
  Your most recent payment was unsuccessful. Please email us at
  <a href="mailto:support@airbrake.io?subject=Invoiced Account Payment"
    class="alert-link">support@airbrake.io</a>
  to avoid any disruption in service.
</ngb-alert>
